<div class="sot-add-prod seed-return-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Add Product(s) to the Request
    </h3>

    <div class="form-sec">
      <div class="row">
        <div class="col-md-12 col-lg-12 smallPadRgt0">
          <app-filter [optionsData]="filterOptionsData" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head" id="divAccountTab">
              <h4>
                Your Account Invoiced Products
              </h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable">
            <table mat-table [dataSource]="accountInvoicedDS" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info cursor-defualt" id="td-ProductName">
                  <div class="d-block d-md-none">Product Name</div>
                  <p> {{element.itemVendorName}}</p>
                  <p class="grower-name">{{element.itemDescription}}</p>
                  <p>{{element.itemNumber}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Lot Number">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Lot Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="d-block d-md-none"> Lot Number</div>
                  <span> {{element.lotNumber}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.treatment}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center ">
                  <span>
                    {{element.productLine}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Availability">
                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Availability </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <div class="d-block d-md-none">Availability</div>
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span> {{element.availableQuantity}} </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="tab-head" id="divParentTab">
              <h4>Parent Account Invoiced Products</h4>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer compInvProdTable">
            <table mat-table [dataSource]="parentAccountDS" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info" id="td-ProductName">
                  <div class="d-block d-md-none">Product Name</div>
                  <p> {{element.itemVendorName}}</p>
                  <p class="grower-name">{{element.itemDescription}}</p>
                  <p>{{element.itemNumber}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Lot Number">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Lot Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="d-block d-md-none">Lot Number</div>
                  <span> {{element.lotNumber}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.treatment}} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center ">
                  <span>
                    {{element.productLine}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Availability">
                <th mat-header-cell *matHeaderCellDef class="text-center availableUnits"> Availability </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <div class="d-block d-md-none">Availability</div>
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span> {{element.availableQuantity}} </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,false)"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-12 col-md-2 padding-l0 padding-sm-l15">
      <button id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    </div>
    <!--<div class="col-md-2 padding-l0" *ngIf="isShowExportButton()">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()">Export</button>
    </div>-->
    <div class="col-12 col-md-10 text-center text-md-right margin-sm-t10" *ngIf="isShowExportButton()">
      <span class="count">Products selected: <span>{{getSelectedCount()}}</span></span>
    </div>
    <div class="col-12 col-md-10 text-center text-md-right margin-sm-t10" *ngIf="!isShowExportButton()">
      <span class="count">Products selected: <span>{{getSelectedCount()}}</span></span>
    </div>
  </div>
</div>
